export const es = {
    languages: {
        cs: 'Checo',
        de: 'Alemán',
        en: 'Inglés',
        es: 'Español',
        fr: 'Francés',
        hr: 'Croata',
        hu: 'Húngaro',
        it: 'Italiano',
        nl: 'Neerlandés',
        pl: 'Polaco',
        ru: 'Ruso',
        sk: 'Eslovaco',
        tr: 'Turco',
        uk: 'Ucraniano',
        undefined: 'Sin subtítulos',
    },
    player: {
        content: {
            notFound: { title: 'Error al cargar el elemento multimedia 😞' },
        },
        controls: {
            backwards: { title: '10s hacia atrás' },
            buffering: { title: 'Cargando...' },
            captions: { title: 'Subtítulos' },
            forwards: { title: '10s hacia adelante' },
            fullscreen: { title: 'Pantalla completa' },
            pause: { title: 'Pausa' },
            play: { title: 'Reproducir' },
            playlist: { title: 'Lista de reproducción' },
            volume: { title: 'Volumen' },
        },
    },
};
